
import { CQAppConstant } from '../../../app-constants';
import { CQFormulaFieldRuleController } from '../../../common/rules/formula-field-rule/formula-field-rule.controller';
import { CQSetValueRuleController } from '../../../common/rules/set-values-rule/set-value-rule.controller';
import { CQLookupFilterRuleController } from '../../../common/rules/lookup-filter-rule/lookup-filter-rule.controller';
import { IToggleRuleObject } from '../../../common/rules/IRules.interface';
import { CQDynamicSourceRuleController } from '../../../common/rules/dynamic-source/dynamic-source-rule/dynamic-source.controller';
import { CQTransferRuleController } from '../../../common/rules/transfer-rule/transfer-rule.controller';
import { CQInvokeActionRuleController } from '../../../common/rules/invoke-action/invoke-action-rule.controller';
import { CQOnInitInvokeActionRuleController } from '../../../common/rules/onInit-invoke/onInit-invoke-rule.controller';
import { CQOnLoadSetValueRuleController } from '../../../common/rules/onLoad-setValue/onLoad-set-value-rule.controller';
import { CQOnLoadInvokeActionRuleController } from '../../../common/rules/onload-invoke/onLoad-invoke-rule.controller';
import { CQOnLoadTransferRuleController } from '../../../common/rules/onload-transfer/onLoad-transfer-rule.controller';
import { CQAfterSaveRedirectToRuleController } from '../../../common/rules/afterSave-redirectTo/afterSave-redirectTo-rule.controller';
import { CQToggleRuleController } from '../../../common/rules/toggle-action/toggle-action-rule.controller';

export const RuleControllerMapper = {
    [CQAppConstant.CQ_RECORD_RULES_TYPES.hidden.key]: {
        getControllerInstance: (ruleObject: IToggleRuleObject) => {
            return new CQToggleRuleController(ruleObject, CQAppConstant.TOGGLE_ACTION_RULE_TYPES[0]);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.readonly.key]: {
        getControllerInstance: (ruleObject: IToggleRuleObject) => {
            return new CQToggleRuleController(ruleObject, CQAppConstant.TOGGLE_ACTION_RULE_TYPES[1]);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.visible.key]: {
        getControllerInstance: (ruleObject: IToggleRuleObject) => {
            return new CQToggleRuleController(ruleObject, CQAppConstant.TOGGLE_ACTION_RULE_TYPES[2]);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.required.key]: {
        getControllerInstance: (ruleObject: IToggleRuleObject) => {
            return new CQToggleRuleController(ruleObject, CQAppConstant.TOGGLE_ACTION_RULE_TYPES[3]);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.formulaFieldHyperlink.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQFormulaFieldRuleController('Hyperlink', ruleObject);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.formulaFieldImage.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQFormulaFieldRuleController('Image', ruleObject);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.dynamicSource.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQDynamicSourceRuleController(ruleObject);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.transfer.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQTransferRuleController(ruleObject);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.setValues.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQSetValueRuleController(ruleObject);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.lookupFilter.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQLookupFilterRuleController(ruleObject);
        }
    },
    [CQAppConstant.CQ_RECORD_RULES_TYPES.invoke.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQInvokeActionRuleController(ruleObject);
        }
    },

    // Event triggered Action on Layout
    [CQAppConstant.COMPONENT_EVENT_RULES_MAP.onInitInvoke.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQOnInitInvokeActionRuleController(ruleObject);
        }
    },
    [CQAppConstant.COMPONENT_EVENT_RULES_MAP.onLoadInvoke.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQOnLoadInvokeActionRuleController(ruleObject);
        }
    },
    [CQAppConstant.COMPONENT_EVENT_RULES_MAP.onLoadsetValues.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQOnLoadSetValueRuleController(ruleObject);
        }
    },
    [CQAppConstant.COMPONENT_EVENT_RULES_MAP.onLoadtransfer.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQOnLoadTransferRuleController(ruleObject);
        }
    },
    [CQAppConstant.COMPONENT_EVENT_RULES_MAP.afterSaveRedirectTo.key]: {
        getControllerInstance: (ruleObject: any) => {
            return new CQAfterSaveRedirectToRuleController(ruleObject);
        }
    }
};
